import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig } from '@ng-dynamic-forms/core';
import { PageBuilderItem, PAGE_BUILDER_CODE_COMPONENT } from '../page-builder-components.models';

export interface PageBuilderTextboxModelConfig extends DynamicInputModelConfig {
}

export class PageBuilderTextboxModel extends DynamicInputModel {
	@serializable() readonly type: string = 'page_builder_textbox'; 

	constructor(config: PageBuilderTextboxModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
	}

	static initModel(_component: PageBuilderItem): PageBuilderTextboxModel { 
		const formModel = new PageBuilderTextboxModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE
		});
		return formModel;
	}

	static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX,
            NAME: 'Textbox',
            ICON: 'text_fields',
            PROPERTIES: [
                { ID: 'CODE', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', VALUE: 'Ligne' },
                { ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
            ]
        };
    }
}